// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C0ix","col":"styles_col__2ZekN"};